/**
 * Service URLs - Local copy for Vite compatibility
 *
 * This file exists because Vite/Rollup has issues with CommonJS re-exports
 * from @ops-matrix/shared-types. This provides the same URLS but in ESM format.
 *
 * @see 1-shared-types/config/ports.json for canonical source
 */

// Import directly from shared-types config - this works with Vite
// because we're not going through the CommonJS index.js
import portsJson from '../../../1-shared-types/config/ports.json';

const { defaults, services } = portsJson;
const { host, httpProtocol } = defaults;

// Build URLs with proper types
export const URLS = {
  // HTTP services
  API_GATEWAY: `${httpProtocol}://${host}:${services.http.API_GATEWAY.port}`,
  INTEGRATION_SERVICE: `${httpProtocol}://${host}:${services.http.INTEGRATION_SERVICE.port}`,
  DOCUMENT_PIPELINE_REST: `${httpProtocol}://${host}:${services.http.DOCUMENT_PIPELINE_REST.port}`,
  // Portals
  ADMIN_PORTAL: `${httpProtocol}://${host}:${services.portals.ADMIN_PORTAL.port}`,
  BUSINESS_PORTAL: `${httpProtocol}://${host}:${services.portals.BUSINESS_PORTAL.port}`,
  CONSUMER_PORTAL: `${httpProtocol}://${host}:${services.portals.CONSUMER_PORTAL.port}`,
  AUTH_PORTAL: `${httpProtocol}://${host}:${services.portals.AUTH_PORTAL.port}`,
} as const;
